export const products = [
  {
    id: 'cleanser-1',
    name: 'The Awakening Cleanser',
    price: 38,
    category: 'Phase I: Purify',
    image: 'https://images.unsplash.com/photo-1556229167-da31d4548633?q=80&w=800&auto=format&fit=crop',
    tag: 'Essential',
    description: 'A low-pH botanical gel that honors the skin barrier while removing environmental pollutants.',
    ingredients: ['Aloe Vera', 'Green Tea', 'Glycerin'],
    usage: 'Morning and evening. Massage into damp skin, rinse with lukewarm water.'
  },
  {
    id: 'essence-1',
    name: 'Luminous Micro-Essence',
    price: 52,
    category: 'Phase II: Hydrate',
    image: 'https://images.unsplash.com/photo-1601049541289-9b1b7bbbfe19?q=80&w=800&auto=format&fit=crop',
    tag: 'Bestseller',
    description: 'Fermented marine botanicals designed to flood the dermis with weightless, long-lasting moisture.',
    ingredients: ['Sea Kelp', 'Hyaluronic Acid', 'Niacinamide'],
    usage: 'After cleansing. Pat into skin until fully absorbed.'
  },
  {
    id: 'serum-1',
    name: 'Midnight Renewal Serum',
    price: 85,
    category: 'Phase III: Repair',
    image: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?q=80&w=800&auto=format&fit=crop',
    tag: 'Advanced',
    description: 'A potent alternative to synthetic retinoids, using Bakuchiol and Squalane for overnight cellular repair.',
    ingredients: ['Bakuchiol', 'Squalane', 'Rosehip Oil'],
    usage: 'Evening only. Apply 2-3 drops before moisturizing.'
  },
  {
    id: 'cream-1',
    name: 'Barrier Defense Cream',
    price: 68,
    category: 'Phase IV: Protect',
    image: 'https://images.unsplash.com/photo-1617897903246-719242758050?q=80&w=800&auto=format&fit=crop',
    tag: 'Daily Ritual',
    description: 'Ceramide-rich lipid complex that mimics the skin’s natural moisture barrier for 24-hour protection.',
    ingredients: ['Ceramides', 'Shea Butter', 'Peptides'],
    usage: 'Morning and evening. Final step in your ritual.'
  }
];

export const bundle = {
  id: 'ritual-set-1',
  name: 'The Essential Ritual Set',
  price: 185,
  originalPrice: 243,
  description: 'The definitive GlowDock experience. A four-step system meticulously engineered to restore radiance and strengthen skin resilience from within.',
  image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?q=80&w=1200&auto=format&fit=crop'
};

export const faqs = [
  {
    question: "How do I know which ritual is right for my skin type?",
    answer: "Our products are formulated to be 'barrier-neutral,' meaning they work with your skin's natural biology regardless of type. If you have specific concerns, we recommend starting with The Awakening Cleanser and Barrier Defense Cream."
  },
  {
    question: "Are your ingredients sustainably sourced?",
    answer: "We prioritize wild-harvested botanicals and ethical laboratory-grown actives. Our goal is high performance with a low environmental footprint."
  },
  {
    question: "Do you offer international shipping?",
    answer: "Yes, we ship the GlowDock experience worldwide. Shipping rates and delivery times are calculated at checkout based on your specific location."
  }
];